import * as AT from "./actionTypes";
import * as MT from "./mutationTypes";
import { UserService } from "../services";
import { ExporterService } from "../services";
import { AccountService } from "../services";

export default {
  [AT.STORE_NAVIGATION_STATE]: (context, data) => {
    context.commit(MT.SET_NAVIGATION_STATE, data);
  },
  [AT.GET_USERS]: () => {
    return UserService.getUsers()
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.DELETE_USER]: (context, id) => {
    return UserService.deleteUser(id)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.ADD_USER]: (context, formData) => {
    return UserService.addUser(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.UPDATE_USER_NAME]: (context, formData) => {
    return UserService.updateUsername(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.ADD_EXPORTER]: (context, formData) => {
    return ExporterService.addExporter(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.UPDATE_EXPORTER]: (context, formData) => {
    return ExporterService.updateExporter(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.GET_EXPORTERS]: context => {
    return ExporterService.getExporters()
      .then(response => {
        context.commit(MT.SET_EXPORTERS, response);
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.DELETE_EXPORTER]: (context, id) => {
    return ExporterService.deleteExporter(id)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.ADD_AD_CODE]: (context, formData) => {
    return ExporterService.addAdCode(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.DELETE_AD_CODE]: (context, id) => {
    return ExporterService.deleteAdCode(id)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.UPDATE_ACCOUNT_SETTINGS]: (context, formData) => {
    return AccountService.updateAccount(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.ADD_TIME_PERIOD]: (context, formData) => {
    return AccountService.addTimePeriod(formData)
      .then(response => {
        context.commit(MT.ADD_TIME_PERIOD, response);
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.GET_TIME_PERIODS]: context => {
    return AccountService.getTimePeriods()
      .then(response => {
        context.commit(MT.SET_TIME_PERIODS, response);
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.DELETE_TIME_PERIOD]: (context, id) => {
    return AccountService.deleteTimePeriod(id)
      .then(response => {
        context.commit(MT.DELETE_TIME_PERIOD, { id: id });
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.UPDATE_TIME_PERIOD]: (context, formData) => {
    return AccountService.updateTimePeriod(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.ADD_NOTIFICATION_REQUEST]: () => {
    return AccountService.notifyRequest()
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.GET_ACCOUNT_DETAILS]: context => {
    return AccountService.getAccountDetails()
      .then(response => {
        context.commit(MT.SET_ACCOUNT_STATE, response);
        return response;
      })
      .catch(error => Promise.reject(error.response));
  }
};
